module.exports = __webpack_public_path__ + "static/media/XC45-logo.7917e5fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/XC45/XC45-logo.svg
// module id = 561
// module chunks = 0